module.exports = __webpack_public_path__ + "img/seminar_banner.2fbe136f.jpg";